module.exports = __webpack_public_path__ + "fonts/LTCCaymanGoudyModern-Italic.885241e330129b45a1ede05744973d2c.ttf";